export default {
  Empty: 'Select a playbook to view its details.',
  Edit: 'Edit',
  Delete: 'Delete',
  Description: 'Description',
  NoDescription: 'No description provided.',
  Steps: 'Steps',
  Rules: 'Rules',
};
